var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g2, _path75, _path76, _path77, _path78, _path79, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2ErgonomicChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1949_10606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.3 894.52L521 898.516L522.8 898.616C522.8 898.616 523.7 899.515 527.1 899.915C530.5 900.314 530.7 900.314 530.7 900.314C530.7 900.314 536.8 900.414 538.2 900.414C539.6 900.414 540.9 900.414 540.9 900.414L542.8 900.614L544.5 895.819L558.3 894.72L574.1 904.011L570.7 906.009L565.9 911.404L583.3 921.394L592.7 916.599L596 928.088L591.2 934.682L590.2 938.378L591.9 938.478C591.9 938.478 592.6 939.077 596.6 939.777C600.5 940.476 599.9 940.476 599.9 940.476C599.9 940.476 604.6 940.676 606.9 940.476C609.2 940.276 610.3 940.276 610.3 940.276L612.1 940.476L613.7 934.482L605 932.783L611.7 925.59C611.7 925.59 628 934.881 628.9 935.381C629.7 935.88 630.5 936.38 631.9 935.581C633.3 934.781 642 930.585 643.4 930.186C644.8 929.786 646 929.586 646.5 929.387C646.9 929.187 652.2 926.09 652.7 925.79C653.2 925.49 652.8 925.191 652.8 925.191L673.9 913.702L678.1 915.2C678.1 915.2 670.9 919.196 668.8 920.695C666.7 922.193 666.9 923.193 668.6 924.491C670.3 925.79 671.9 926.29 673.8 927.089C675.7 927.888 677.9 927.988 679.9 926.789C681.9 925.59 724.9 901.513 726.4 900.314C727.9 899.116 729.2 898.116 726.4 896.518C723.6 894.82 722.7 894.52 721.6 893.821C720.5 893.121 717.5 893.021 715 894.42C712.5 895.819 691.7 907.408 691.7 907.408L697.4 901.513L699 900.414C699 900.414 722.5 887.826 725 886.028C727.5 884.23 730 879.634 726.9 876.637C723.8 873.64 676.8 845.167 676.8 845.167L656.1 833.079L650 830.681C650 830.681 644.5 827.184 637.9 828.183C631.2 829.182 592.2 840.871 592.2 840.871L585 843.469L580.6 843.569L566.8 844.667L565.7 848.364L567.3 848.464C567.3 848.464 568.6 849.163 570.3 849.363C572.1 849.563 573.2 849.663 573.2 849.663L560.5 857.655L552.3 872.941C552.3 872.941 549.3 874.839 548.8 877.037C548.3 879.334 548.6 880.933 548.6 880.933L544.8 882.431L541.8 884.629L551.5 890.723L537.7 892.322L522.3 894.52Z",
    fill: "#181818"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.511 722.969L586.948 710.015L594.615 714.408L589.542 717.337L588.978 717.675L568.006 723.082C567.893 723.082 566.427 722.969 564.511 722.969Z",
    fill: "#605657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.257 820.97L587.4 813.986L587.625 813.536L587.851 813.085L588.189 812.522L588.415 812.071L588.753 811.733L589.091 811.283L589.429 810.945L589.88 810.494L590.218 810.156L590.67 809.819L591.121 809.481L591.572 809.255L592.135 808.917L592.586 808.692L593.15 808.467L593.601 808.241L594.165 808.129L594.729 808.016L595.292 807.904L595.856 807.791L596.533 807.678H597.096H597.66H598.337H599.013L599.577 807.791L600.254 807.904L600.817 808.016L601.494 808.129L602.057 808.354L602.621 808.579L603.185 808.805L603.749 809.03L604.312 809.368L604.764 809.593L605.327 809.931L605.778 810.269L606.342 810.72L606.793 811.058L607.244 811.508L607.695 811.846L608.033 812.297L608.485 812.747L608.823 813.198L609.161 813.648L609.499 814.212L609.725 814.662L610.063 815.226L610.288 815.789L610.514 816.239L610.74 816.802L610.852 817.366L610.965 817.929L611.078 818.492L611.19 819.055V819.619L611.303 820.182L609.274 826.715L585.257 820.97Z",
    fill: "#766C60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.877 809.706L605.328 809.931L605.779 810.269L606.342 810.72L606.794 811.058L607.244 811.508L607.695 811.846L608.034 812.297L608.485 812.747L608.823 813.198L609.161 813.649L609.499 814.212L609.725 814.662L610.063 815.226L610.289 815.789L610.514 816.239L610.74 816.803L610.852 817.366L610.965 817.929L611.078 818.492L611.191 819.055V819.619L611.304 820.182L609.274 826.715L593.038 822.773L590.67 815.113L589.43 814.888L589.655 813.649L595.405 810.945L604.877 809.706Z",
    fill: "#231D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.219 810.269L590.783 809.819L591.234 809.481L591.685 809.143L592.136 808.917L592.587 808.692L593.151 808.467L593.714 808.242L594.278 808.016L594.842 807.904L595.406 807.791L595.969 807.678L596.533 807.566H597.097H597.661H598.337H599.014L599.69 807.678L600.367 807.791L600.93 807.904L601.494 808.016L602.058 808.242L602.622 808.467L603.186 808.692L603.749 808.917L604.313 809.143L604.877 809.481L605.441 809.819L605.892 810.157L606.343 810.494L606.794 810.832L607.245 811.283L607.696 811.733L608.147 812.184L608.485 812.635L608.823 813.085L609.161 813.536L609.5 813.986L609.838 814.437L610.064 815L610.289 815.563L610.514 816.127L610.74 816.69L610.853 817.253L610.966 817.816L611.078 818.38L611.191 818.943V819.506C610.627 818.38 609.838 817.14 609.161 816.239C607.696 814.55 604.313 812.184 599.803 811.621C595.293 811.058 591.91 813.536 591.91 813.536L590.219 810.269Z",
    fill: "url(#paint0_linear_1949_10606)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.601 809.03C593.601 809.03 593.601 811.283 593.601 811.508C593.601 811.846 593.489 812.297 592.925 812.973C592.136 813.987 588.978 815.564 587.738 814.775V806.665L593.601 809.03Z",
    fill: "url(#paint1_linear_1949_10606)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.004 826.152L607.244 824.8H607.695L606.455 828.63L605.779 827.954L605.891 827.504V827.053L606.004 826.603V826.152Z",
    fill: "#4E4631"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.984 814.099C603.749 814.775 609.274 820.407 609.274 826.603L606.793 826.377C606.793 831.334 602.396 834.938 596.984 834.488C591.571 833.925 587.174 829.531 587.174 824.462L584.694 824.237C584.694 818.042 590.218 813.423 596.984 814.099Z",
    fill: "#35281F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.983 814.099C603.748 814.775 609.273 820.407 609.273 826.603L606.793 826.377C606.793 831.334 602.395 834.938 596.983 834.488C596.42 834.488 595.969 834.375 595.405 834.262L594.954 829.306L590.669 815.113C592.473 814.324 594.728 813.874 596.983 814.099Z",
    fill: "#251E18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.46 832.348L593.15 814.662L587.738 808.805L603.749 805.651L628.78 819.506C628.78 819.506 628.667 820.182 628.442 821.196C626.638 821.534 625.059 822.21 623.594 822.998C620.887 824.575 619.534 826.603 619.534 828.63V831.897C616.941 832.122 614.46 832.348 614.46 832.348Z",
    fill: "#626049"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.985 826.715C619.985 826.715 597.096 808.016 597.096 808.467C597.096 808.918 609.161 803.285 609.161 803.285L628.216 814.662L624.27 825.138L619.985 826.715Z",
    fill: "#54555A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.384 853.074C647.384 855.102 646.031 857.129 643.325 858.706C640.619 860.283 637.011 861.072 633.516 861.072C630.02 861.072 626.412 860.283 623.706 858.706C621 857.129 619.647 855.102 619.647 853.074C619.647 851.385 619.647 830.32 619.647 828.518C619.647 826.49 621 824.462 623.706 822.885C626.412 821.308 630.02 820.52 633.516 820.52C637.011 820.52 640.619 821.308 643.325 822.885C646.031 824.462 647.384 826.49 647.384 828.518C647.384 830.32 647.384 851.385 647.384 853.074Z",
    fill: "url(#paint2_linear_1949_10606)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.401 831.109L696.544 824.124L696.769 823.674L696.995 823.111L697.333 822.66L697.559 822.21L697.897 821.872L698.235 821.421L698.686 820.971L699.024 820.633L699.475 820.295L699.814 819.957L700.265 819.619L700.715 819.393L701.279 819.055L701.73 818.83L702.294 818.605L702.745 818.38L703.309 818.267L703.873 818.154L704.436 817.929H705L705.677 817.816H706.24H706.917H707.481H708.157L708.721 817.929L709.398 818.042L709.961 818.154L710.638 818.267L711.201 818.492L711.765 818.718L712.329 818.943L712.893 819.168L713.457 819.506L714.02 819.731L714.471 820.069L715.035 820.407L715.486 820.858L715.937 821.196L716.388 821.534L716.839 821.984L717.177 822.435L717.628 822.885L717.967 823.336L718.305 823.787L718.643 824.35L718.982 824.8L719.207 825.364L719.432 825.814L719.658 826.377L719.883 826.941L719.996 827.504L720.109 828.067L720.222 828.63L720.335 829.194L720.447 829.757V830.32L718.418 836.853L694.401 831.109Z",
    fill: "url(#paint3_linear_1949_10606)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.745 819.055C702.745 819.055 702.745 821.308 702.745 821.534C702.745 821.872 702.633 822.322 702.069 822.998C701.28 824.012 698.123 825.589 696.882 824.8V816.69L702.745 819.055Z",
    fill: "url(#paint4_linear_1949_10606)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.148 836.29L716.389 834.938H716.839L715.599 838.768L714.923 838.092L715.036 837.642L715.148 837.191V836.741V836.29Z",
    fill: "#4E4631"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.128 824.237C712.893 824.913 718.418 830.545 718.418 836.741L715.937 836.515C715.937 841.472 711.54 845.076 706.128 844.626C700.716 844.063 696.318 839.669 696.318 834.6L693.838 834.375C693.838 828.18 699.363 823.561 706.128 824.237Z",
    fill: "url(#paint5_linear_1949_10606)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.384 830.545V840.796L692.146 824.462H692.259L692.484 824.35L692.597 824.237L692.935 824.124L693.161 823.899L693.612 823.674L693.95 823.561L694.401 823.223L694.852 822.998L695.303 822.773L695.754 822.547L696.318 822.21L696.882 821.872L697.445 821.646L698.009 821.308L698.46 821.083L699.024 820.745L699.588 820.407L700.151 820.182L700.603 819.844L701.166 819.619L701.617 819.281L702.068 819.055L702.519 818.83L702.858 818.605L703.196 818.38L703.534 818.267L703.76 818.154L703.985 818.042L704.098 817.929L704.211 817.816L704.436 817.704L704.549 817.478V817.253V807.002V807.228L704.436 807.453L704.211 807.566L704.098 807.678L703.985 807.791L703.76 807.904L703.534 808.016L703.196 808.129L702.858 808.354L702.519 808.579L702.068 808.805L701.617 809.03L701.166 809.368L700.603 809.593L700.151 809.931L699.588 810.157L699.024 810.494L698.46 810.72L698.009 811.058L697.445 811.396L696.882 811.621L696.318 811.959L695.754 812.297L695.303 812.522L694.852 812.747L694.401 812.973L693.95 813.198L693.612 813.423L693.161 813.649L692.935 813.761L692.597 813.986L692.484 814.099H692.259L692.146 814.212L647.384 830.545Z",
    fill: "url(#paint6_linear_1949_10606)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.384 830.545L692.259 814.212C692.259 814.212 703.76 808.016 704.324 807.566C704.888 807.115 704.775 806.552 704.098 805.989C703.422 805.425 702.971 804.975 701.956 804.524C700.941 804.186 699.701 804.074 698.799 804.637C697.897 805.087 688.2 810.832 688.2 810.832L636.898 825.927L645.129 830.658L647.384 830.545Z",
    fill: "#53565D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711.428 893.964L713.57 887.093L713.796 886.53L714.021 886.079L714.247 885.629L714.585 885.178L714.923 884.728L715.262 884.39L715.6 883.939L715.938 883.601L716.389 883.263L716.84 882.925L717.291 882.587L717.742 882.249L718.193 882.024L718.757 881.799L719.208 881.573L719.772 881.348L720.335 881.236L720.899 881.01L721.463 880.898L722.027 880.785H722.59L723.267 880.672H723.831H724.507L725.071 880.785L725.748 880.898H726.311L726.988 881.123L727.551 881.236L728.115 881.461L728.792 881.686L729.356 881.911L729.919 882.137L730.37 882.362L730.934 882.7L731.498 883.038L731.949 883.376L732.4 883.714L732.851 884.164L733.302 884.502L733.753 884.953L734.204 885.403L734.542 885.854L734.993 886.305L735.332 886.755L735.557 887.206L735.895 887.769L736.121 888.22L736.459 888.783L736.684 889.346L736.797 889.909L737.023 890.472L737.135 891.036L737.248 891.599L737.361 892.162V892.725V893.289L735.444 899.709L711.428 893.964Z",
    fill: "url(#paint7_linear_1949_10606)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.771 882.024C719.771 882.024 719.771 884.277 719.771 884.502C719.771 884.84 719.658 885.291 719.094 885.967C718.305 886.98 715.148 888.557 713.907 887.769V879.658L719.771 882.024Z",
    fill: "url(#paint8_linear_1949_10606)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.154 887.206C729.919 887.881 735.444 893.514 735.444 899.709L732.964 899.484C732.964 904.44 728.566 908.045 723.154 907.594C717.742 907.031 713.345 902.638 713.345 897.569L710.864 897.344C710.864 891.035 716.389 886.53 723.154 887.206Z",
    fill: "url(#paint9_linear_1949_10606)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.634 839.895V849.92L703.535 878.419L703.647 878.532H703.873L704.098 878.645H704.324L704.662 878.757L705 878.87L705.452 878.983L705.902 879.095L706.466 879.32L706.917 879.433L707.481 879.658L708.045 879.771L708.608 879.996L709.285 880.109L709.849 880.334L710.525 880.447L711.089 880.672L711.653 880.898L712.329 881.01L712.893 881.236L713.457 881.348L714.021 881.573L714.472 881.686L715.036 881.799L715.486 881.911L715.825 882.024L716.276 882.137L716.614 882.249L716.839 882.362H717.065L717.178 882.475H717.403L717.629 882.587H717.854L718.08 882.7H718.305H718.531H718.756H718.869H719.094H719.32L719.433 882.587H719.658L719.884 882.475L719.997 882.362L720.222 882.249L720.447 882.024L720.786 881.799L721.011 881.461L721.237 881.236L721.462 881.123L721.575 880.898L721.688 880.785L721.801 880.672L721.913 880.447V880.334L722.026 880.222V880.109V879.996L722.139 879.884V869.858L722.026 870.084V870.196L721.913 870.309V870.422V870.534L721.801 870.647L721.688 870.76L721.575 870.872L721.462 871.097L721.237 871.323L721.011 871.548L720.786 871.773L720.447 872.111L720.222 872.224L719.997 872.337L719.884 872.449L719.658 872.562H719.433L719.32 872.675H719.094H718.869H718.756H718.531H718.305H718.08L717.854 872.562H717.629L717.403 872.449H717.178H717.065L716.839 872.337L716.614 872.224L716.276 872.111H715.825L715.486 871.886L715.036 871.773L714.472 871.661L714.021 871.548L713.457 871.323L712.893 871.21L712.329 870.985L711.653 870.872L711.089 870.647L710.525 870.534L709.849 870.309L709.285 870.084L708.608 869.971L708.045 869.746L707.481 869.633L706.917 869.408L706.466 869.295L705.902 869.182L705.452 868.957L705 868.845L704.662 868.732L704.324 868.619H704.098L703.873 868.507H703.647L703.535 868.394L641.634 839.895Z",
    fill: "url(#paint10_linear_1949_10606)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.912 876.392L703.534 878.419L703.647 878.532H703.873L704.098 878.645H704.324L704.662 878.757L705 878.87L705.451 878.983L705.902 879.095L706.466 879.32L706.917 879.433L707.481 879.658L708.044 879.771L708.608 879.996L709.285 880.109L709.849 880.334L710.525 880.447L711.089 880.672L711.653 880.897L712.329 881.01L712.893 881.235L713.457 881.348L714.02 881.573L714.472 881.686L715.035 881.799L715.486 881.911L715.824 882.024L716.275 882.136L716.614 882.249L716.839 882.362H717.065L717.177 882.474H717.403L717.628 882.587H717.854L718.08 882.7H718.305H718.53H718.756H718.869H719.094H719.32L719.432 882.587H719.658L719.883 882.474L719.996 882.362L720.222 882.249L720.447 882.024L720.785 881.799L721.011 881.461L721.237 881.235L721.462 881.123L721.575 880.897L721.688 880.785L721.8 880.672L721.913 880.447V880.334L722.026 880.222V880.109V879.996L722.138 879.884V869.858L722.026 870.084V870.196L721.913 870.309V870.422V870.534L721.8 870.647L721.688 870.759L721.575 870.872L721.462 871.097L721.237 871.323L721.011 871.548L720.785 871.773L720.447 872.111L720.222 872.224L719.996 872.336L719.883 872.449L719.658 872.562H719.432L719.32 872.674H719.094H718.869H718.756H718.53H718.305H718.08L717.854 872.562H717.628L717.403 872.449H717.177H717.065L716.839 872.336L716.614 872.224L716.275 872.111H715.824L715.486 871.886L715.035 871.773L714.472 871.661L714.02 871.548L713.457 871.323L712.893 871.21L712.329 870.985L711.653 870.872L711.089 870.647L710.525 870.534L709.849 870.309L709.285 870.084L708.608 869.971L708.044 869.746L707.481 869.633L706.917 869.408L706.466 869.295L705.902 869.182L705.451 868.957L705 868.844L704.662 868.732L704.324 868.619H704.098L703.873 868.506H703.647L703.534 868.394L698.912 866.366V876.392Z",
    fill: "url(#paint11_linear_1949_10606)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.634 839.895L703.535 868.394C703.535 868.394 715.937 872.111 717.178 872.449C718.418 872.787 719.32 872.9 720.335 872.111C721.35 871.21 721.575 870.872 721.801 870.534C722.026 870.196 722.59 869.295 720.335 868.619C718.08 867.943 706.805 864.451 706.805 864.451L647.271 833.474C647.271 835.502 645.918 837.529 643.212 839.106C642.761 839.444 642.197 839.67 641.634 839.895Z",
    fill: "url(#paint12_linear_1949_10606)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.535 868.394C703.535 868.394 715.938 872.111 717.178 872.449C718.419 872.787 719.321 872.9 720.335 872.111C721.35 871.21 721.576 870.872 721.801 870.534C722.027 870.196 722.59 869.295 720.335 868.619C718.08 867.943 706.805 864.451 706.805 864.451L703.535 868.394Z",
    fill: "#4A4D56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.22 922.914L615.362 916.043L615.587 915.479L615.813 915.029L616.039 914.578L616.377 914.128L616.715 913.677L617.053 913.339L617.392 912.889L617.73 912.551L618.181 912.213L618.632 911.875L619.083 911.537L619.534 911.199L619.985 910.974L620.549 910.748L621 910.523L621.563 910.298L622.127 910.185L622.691 909.96L623.255 909.847L623.818 909.734H624.382L624.946 909.622H625.623H626.186L626.863 909.734H627.539L628.103 909.847L628.78 910.072L629.343 910.185L629.907 910.41L630.471 910.523L631.035 910.861L631.598 911.086L632.162 911.311L632.726 911.649L633.29 911.987L633.741 912.325L634.192 912.663L634.643 913.114L635.094 913.452L635.545 913.902L635.996 914.353L636.334 914.803L636.672 915.254L637.01 915.705L637.349 916.155L637.687 916.719L637.912 917.169L638.138 917.732L638.364 918.296L638.589 918.859L638.815 919.422L638.927 919.985L639.04 920.548V921.112L639.153 921.675V922.238L637.236 928.659L613.22 922.914Z",
    fill: "url(#paint13_linear_1949_10606)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.646 877.631L537.789 870.76L538.014 870.196L538.24 869.746L538.465 869.295L538.803 868.845L539.142 868.394L539.48 867.943L539.818 867.606L540.269 867.268L540.607 866.93L541.059 866.592L541.509 866.254L541.961 865.916L542.412 865.691L542.975 865.465L543.426 865.24L543.99 865.015L544.554 864.789L545.117 864.677L545.681 864.564L546.245 864.451H546.809L547.485 864.339H548.049H548.726L549.29 864.451H549.966L550.53 864.564L551.206 864.677L551.77 864.902L552.334 865.127L553.01 865.24L553.574 865.465L554.138 865.803L554.589 866.029L555.153 866.366L555.716 866.704L556.167 867.042L556.618 867.38L557.182 867.718L557.52 868.169L557.971 868.619L558.422 869.07L558.761 869.521L559.211 869.971L559.55 870.422L559.775 870.872L560.114 871.435L560.339 871.886L560.677 872.449L560.903 873.012L561.016 873.576L561.241 874.026L561.354 874.59L561.467 875.265L561.579 875.829V876.392V876.955L559.663 883.376L535.646 877.631Z",
    fill: "url(#paint14_linear_1949_10606)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.495 866.929L541.058 866.479L541.509 866.141L541.96 865.803L542.411 865.578L542.862 865.353L543.426 865.127L543.99 864.902L544.553 864.677L545.117 864.564L545.681 864.451L546.245 864.339L546.808 864.226H547.372H547.936H548.613H549.289L549.966 864.339L550.642 864.451L551.206 864.564L551.77 864.677L552.334 864.902L552.897 865.127L553.461 865.353L554.025 865.578L554.589 865.803L555.152 866.141L555.716 866.479L556.167 866.817L556.618 867.155L557.069 867.493L557.52 867.943L557.971 868.394L558.422 868.844L558.76 869.295L559.099 869.746L559.437 870.196L559.775 870.647L560.113 871.097L560.339 871.661L560.564 872.224L560.79 872.787L561.015 873.35L561.128 873.914L561.241 874.477L561.354 875.04L561.466 875.603V876.166C560.903 875.04 560.113 873.801 559.437 872.9C557.971 871.21 554.589 868.844 550.078 868.281C545.568 867.718 542.186 870.196 542.186 870.196L540.495 866.929Z",
    fill: "url(#paint15_linear_1949_10606)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.392 912.889L617.73 912.551L618.181 912.213L618.632 911.875L619.083 911.537L619.534 911.199L619.985 910.974L620.436 910.748L621 910.523L621.564 910.298L622.127 910.072L622.691 909.96L623.255 909.847L623.819 909.734L624.382 909.622H624.946H625.51H625.848C625.51 911.311 624.834 913.452 624.27 913.79C623.706 914.24 619.196 916.043 619.196 916.043L617.392 912.889Z",
    fill: "#1C1815"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.564 910.974C621.564 910.974 621.564 913.227 621.564 913.452C621.564 913.79 621.451 914.241 620.887 914.916C620.098 915.93 616.941 917.507 615.701 916.719V908.608L621.564 910.974Z",
    fill: "url(#paint16_linear_1949_10606)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.99 865.69C543.99 865.69 543.99 867.943 543.99 868.169C543.99 868.507 543.878 868.957 543.314 869.633C542.525 870.647 539.367 872.224 538.127 871.435V863.325L543.99 865.69Z",
    fill: "url(#paint17_linear_1949_10606)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.854 928.096L635.207 926.857H635.545L634.418 930.687L633.741 929.898V929.447L633.854 928.997V928.546V928.096Z",
    fill: "#4E4631"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.393 882.812L557.633 881.573H557.972L556.844 885.403L556.168 884.615L556.28 884.164V883.714V883.263L556.393 882.812Z",
    fill: "#4E4631"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.946 916.155C631.711 916.831 637.236 922.464 637.236 928.659L634.755 928.434C634.755 933.39 630.358 936.995 624.946 936.544C619.534 935.981 615.137 931.588 615.137 926.519L612.656 926.294C612.656 919.985 618.068 915.48 624.946 916.155Z",
    fill: "#4D4230"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.373 870.872C554.138 871.548 559.663 877.18 559.663 883.376L557.182 883.15C557.182 888.107 552.785 891.711 547.373 891.261C541.96 890.698 537.563 886.304 537.563 881.235L535.083 881.01C535.083 874.702 540.607 870.196 547.373 870.872Z",
    fill: "#4D4230"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.213 822.885C645.919 824.462 647.272 826.49 647.272 828.518C647.272 830.545 645.919 832.573 643.213 834.15C640.507 835.727 636.899 836.515 633.403 836.515C629.908 836.515 626.3 835.727 623.594 834.15C620.888 832.573 619.535 830.545 619.535 828.518C619.535 826.49 620.888 824.462 623.594 822.885C626.3 821.308 629.908 820.52 633.403 820.52C636.899 820.52 640.507 821.308 643.213 822.885Z",
    fill: "url(#paint18_linear_1949_10606)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.761 828.63C642.761 829.982 641.859 831.334 640.055 832.46C638.251 833.474 635.883 834.037 633.515 834.037C631.147 834.037 628.779 833.474 626.975 832.46C625.171 831.446 624.269 829.982 624.269 828.63C624.269 824.35 624.269 824.575 624.269 820.295C624.269 818.943 625.171 817.591 626.975 816.465C628.779 815.451 631.147 814.888 633.515 814.888C635.883 814.888 638.251 815.451 640.055 816.465C641.859 817.479 642.761 818.943 642.761 820.295C642.761 824.575 642.761 824.237 642.761 828.63Z",
    fill: "url(#paint19_linear_1949_10606)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.687 841.134V851.385L624.27 901.737V901.85V901.962V902.075V902.3L624.157 902.526L624.044 902.751L623.931 903.089L623.818 903.427L623.706 903.765L623.593 904.102L623.48 904.44L623.368 904.778L623.255 905.116L623.142 905.567L623.029 906.017L622.916 906.468L622.804 906.919L622.691 907.369L622.578 907.82L622.465 908.158L622.353 908.496L622.24 908.834L622.127 909.171L622.015 909.509L621.902 909.847L621.789 910.073L621.676 910.298L621.563 910.523L621.451 910.636V910.748V910.861L621.338 910.974L621.225 911.086L621.112 911.199L621 911.312L620.887 911.424L620.774 911.537L620.661 911.65L620.436 911.762L620.21 911.875L619.985 911.988H619.76H619.534H619.308H618.97H618.632H618.294H617.955H617.617H617.279H616.941H616.602H616.264L615.926 911.875L615.587 911.762L615.362 911.65L615.137 911.537L614.911 911.424L614.686 911.312L614.573 911.199L614.46 911.086L614.347 910.861V910.636V900.385C614.46 901.174 619.196 901.512 621 895.204L621.112 894.866L621.225 894.528L621.338 894.077L621.451 893.627L621.563 893.176L623.029 895.879L623.142 895.429L623.255 894.978L623.368 894.64L623.48 894.302L623.593 893.964L623.706 893.627L623.818 893.289L623.931 892.951L624.044 892.613L624.157 892.387L624.27 892.162V891.937V891.824V891.711V891.599L637.687 841.134Z",
    fill: "url(#paint20_linear_1949_10606)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.687 841.134V851.385L631.599 874.59L629.231 872.9L637.687 841.134Z",
    fill: "url(#paint21_linear_1949_10606)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.688 841.134L624.27 891.486C624.27 891.486 622.128 899.822 621.677 900.498C621.226 901.174 620.437 901.624 618.52 901.624C616.603 901.624 614.461 901.286 614.461 900.273C614.461 899.259 616.942 891.374 616.942 891.374L625.06 840.008L637.688 841.134Z",
    fill: "url(#paint22_linear_1949_10606)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.819 893.514C623.142 895.992 622.015 900.047 621.789 900.498C621.338 901.174 620.549 901.624 618.632 901.624C616.715 901.624 614.573 901.286 614.573 900.273C614.573 899.259 617.054 891.374 617.054 891.374L617.392 889.571L620.098 891.486L623.819 893.514Z",
    fill: "#635957"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.382 891.486C624.382 891.486 622.24 899.822 621.789 900.498C621.338 901.174 620.549 901.624 618.632 901.624C616.715 901.624 614.573 901.286 614.573 900.273C614.573 899.259 617.054 891.374 617.054 891.374L624.382 891.486Z",
    fill: "#302A2E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.819 893.514C623.142 895.992 622.015 900.047 621.789 900.498C621.338 901.174 620.549 901.624 618.632 901.624C616.715 901.624 614.573 901.286 614.573 900.273C614.573 899.259 617.054 891.374 617.054 891.374L619.985 891.486L623.819 893.514Z",
    fill: "#544741"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.127 838.093V848.118L554.025 864.789H553.912H553.686L553.461 864.902H553.01H552.672H552.22L551.657 865.015H551.093L550.529 865.127H549.965L549.289 865.24H548.612L547.823 865.353H547.147L546.47 865.465H545.681L545.004 865.578H544.215L543.539 865.691H542.862L542.186 865.803H541.622L541.058 865.916H540.494L539.931 866.029H539.479H539.141H538.803L538.465 866.141H538.239H538.126H538.014H537.788L537.675 866.029H537.45L537.337 865.916L537.112 865.803L536.999 865.691H536.886L536.661 865.578L536.548 865.465L536.435 865.353L536.322 865.24L536.21 865.127L536.097 865.015L535.984 864.902V864.789L535.871 864.564V864.339V864.113L535.759 863.888V853.863L539.028 852.173V852.399L539.141 852.624V852.849L539.254 852.962V853.074L539.367 853.187L539.479 853.3L539.592 853.412L539.705 853.525L539.818 853.638H540.043L540.156 853.75L540.381 853.863L540.494 853.975L540.72 854.088H540.833H541.058L541.171 854.201H541.396H541.509L541.622 854.088H541.96H542.298H542.636L543.088 853.975H543.651H544.215L544.779 853.863H545.455L546.019 853.75H546.808L547.485 853.638H548.161L545.681 855.44H546.47L547.147 855.327H547.823L548.612 855.215H549.289L549.965 855.102H550.529L551.093 854.989H551.657H552.22L552.672 854.877H553.01H553.461L553.686 854.764H553.912H554.025L622.127 838.093Z",
    fill: "url(#paint23_linear_1949_10606)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.127 838.093V848.118L574.094 859.833V849.92L622.127 838.093Z",
    fill: "url(#paint24_linear_1949_10606)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.127 838.092L554.025 854.764C554.025 854.764 539.028 856.116 538.126 856.116C537.224 856.116 536.21 855.215 535.984 854.764C535.759 854.313 535.759 853.299 535.759 853.299C535.759 853.299 535.871 852.398 537.45 852.173C538.916 851.948 553.122 850.483 553.122 850.483L619.534 830.771V833.474C619.534 835.164 620.436 836.741 622.127 838.092Z",
    fill: "url(#paint25_linear_1949_10606)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.392 854.201L554.025 854.764C554.025 854.764 539.028 856.116 538.126 856.116C537.224 856.116 536.21 855.215 535.984 854.764C535.759 854.313 535.759 853.299 535.759 853.299C535.759 853.299 535.871 852.398 537.45 852.173C538.465 852.06 545.906 851.159 550.191 850.709L553.799 853.074L556.392 854.201Z",
    fill: "#6A6667"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.075 870.422L715.487 867.155L720.448 868.619L717.403 870.422L712.104 870.985L710.075 870.422Z",
    fill: "#676163"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.397 695.935L541.51 696.047L541.623 696.16L541.735 696.272L541.848 696.385L541.961 696.498L542.073 696.61L542.299 696.723L542.525 696.836L542.75 696.948L542.976 697.061L543.201 697.174L543.426 697.286L543.652 697.399L543.878 697.512L544.103 697.624L544.329 697.849L544.554 698.075L544.78 698.3L545.005 698.525L545.231 698.638L545.456 698.751L545.681 698.863L545.907 698.976L546.133 699.089L546.358 699.201L546.584 699.314L546.809 699.427L547.035 699.539L547.26 699.652L547.486 699.765L547.598 699.877L547.824 699.99L548.049 700.102L548.275 700.215L548.5 700.328H548.726H548.951H549.177H549.402H549.628H549.854H550.079H550.304H550.53H550.755H550.981H551.207H551.432H551.657L551.883 700.215L552.109 700.102L552.334 699.99L552.559 699.877L552.785 699.765L553.01 699.652L553.236 699.539L553.462 699.427L553.687 699.314L553.912 699.201L554.138 699.089L554.364 698.976L554.589 698.751L554.927 698.525L555.491 698.075L556.28 697.512L557.295 696.723L558.535 695.822L560.001 694.808L561.58 693.682L563.271 692.443L565.075 691.091L566.992 689.739L569.021 688.275C572.742 685.684 576.463 683.093 580.071 680.502L582.326 678.925C585.258 676.898 588.077 674.87 591.008 672.73L593.037 671.265L594.954 669.914L596.758 668.674L598.45 667.548L599.915 666.534L601.268 665.633L602.396 664.845L603.298 664.169L603.975 663.718L604.426 663.38L604.651 663.268L604.876 663.155L605.102 662.93L605.328 662.704L605.553 662.479L605.666 662.254L605.779 662.028L605.891 661.69L606.004 661.352V661.015V660.677L605.553 655.833L539.818 689.739L540.27 694.583V694.808L540.382 695.033L540.495 695.259L540.608 695.484L540.72 695.709L541.397 695.935Z",
    fill: "url(#paint26_linear_1949_10606)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.946 691.203C540.946 691.203 545.569 694.245 547.26 695.259C548.952 696.16 551.883 696.16 554.364 694.245C556.844 692.33 603.636 659.438 604.651 658.649C605.553 657.861 606.906 655.72 604.989 654.256C603.073 652.791 599.916 651.102 599.126 650.539C598.337 649.975 594.955 649.412 593.263 650.539C591.572 651.665 542.299 686.022 541.059 687.261C540.044 688.5 540.044 690.19 540.946 691.203Z",
    fill: "#746E70"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.842 807.34L677.602 805.651L685.72 800.694L687.863 804.975L683.916 807.904L678.842 807.34Z",
    fill: "#191814"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.096 808.917L597.209 804.637L594.164 798.892L582.777 796.301L591.008 809.368L597.096 808.917Z",
    fill: "#080904"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.412 755.974V768.928V769.266L542.524 769.604V769.942L542.637 770.28L542.75 770.618L542.975 770.956L543.088 771.294L543.201 771.632L543.426 771.97L543.652 772.308L543.877 772.646L544.216 772.984L544.441 773.322L544.779 773.66L545.118 773.997L545.569 774.335L545.907 774.673L546.358 775.011L546.809 775.349L547.373 775.8L547.936 776.138L548.5 776.476L549.177 776.926L549.853 777.264L550.643 777.827L551.883 778.503L553.348 779.292L555.04 780.306L557.069 781.432L559.324 782.784L561.692 784.136L564.398 785.713L567.104 787.29L570.036 788.979L573.193 790.782L576.237 792.584L579.507 794.386L582.777 796.301L586.047 798.216L589.429 800.131L592.699 802.046L595.969 803.961L599.126 805.763L602.283 807.566L605.327 809.255L608.146 810.945L610.965 812.522L613.558 813.986L615.926 815.451L618.069 816.69L619.985 817.816L621.677 818.718L623.03 819.506L624.157 820.182L624.946 820.632L625.285 820.858L625.623 820.97L625.961 821.196L626.299 821.308L626.75 821.534L627.314 821.646L627.991 821.872L628.554 822.097L629.344 822.21L630.133 822.435L630.922 822.548L631.824 822.773L632.726 822.885L633.628 822.998L634.643 823.111L635.658 823.223L636.785 823.336H637.913H639.04H640.168L641.408 823.223L642.648 823.111L643.889 822.885L645.129 822.773L646.369 822.435L647.722 822.097L648.963 821.759L650.316 821.308L651.669 820.858L652.909 820.295L654.262 819.619L655.615 818.943L656.855 818.154L658.321 817.253L660.012 816.239L662.042 815.113L664.184 813.761L666.552 812.297L669.033 810.72L671.738 809.143L674.557 807.453L677.602 805.651L680.646 803.736L683.803 801.821L687.073 799.906L690.23 797.878L693.613 795.963L696.882 793.936L700.152 791.908L703.422 789.993L706.579 787.965L709.736 786.163L712.781 784.248L715.712 782.446L718.531 780.756L721.124 779.179L723.605 777.715L725.972 776.25L728.002 775.011L729.919 773.885L731.497 772.871L732.85 771.97L733.978 771.294L734.767 770.843L735.218 770.505L735.444 770.28L735.782 770.055L736.12 769.717L736.459 769.492L736.797 769.154L737.135 768.703L737.473 768.365L737.811 767.915L738.037 767.464L738.375 767.014L738.714 766.563L738.939 766L739.164 765.436L739.39 764.986L739.615 764.423L739.728 763.859L739.954 763.296V762.733V749.779V750.342L739.728 750.905L739.615 751.468L739.39 752.032L739.164 752.595L738.939 753.158L738.714 753.609L738.375 754.059L738.037 754.623L737.811 754.961L737.473 755.411L737.135 755.862L736.797 756.2L736.459 756.538L736.12 756.875L735.782 757.101L735.444 757.439L735.218 757.664L734.767 757.889L733.978 758.453L732.85 759.128L731.497 759.917L729.919 760.931L728.002 762.057L725.972 763.409L723.605 764.761L721.124 766.338L718.531 767.915L715.712 769.604L712.781 771.407L709.736 773.209L706.579 775.124L703.422 777.039L700.152 779.066L696.882 780.982L693.613 783.009L690.23 785.037L687.073 786.952L683.803 788.979L680.646 790.894L677.602 792.697L674.557 794.499L671.738 796.189L669.033 797.878L666.552 799.455L664.184 800.807L662.042 802.159L660.012 803.398L658.321 804.412L656.855 805.313L655.615 806.101L654.262 806.777L652.909 807.453L651.669 808.016L650.316 808.467L648.963 808.917L647.722 809.255L646.369 809.593L645.129 809.819L643.889 810.044L642.648 810.157L641.408 810.269L640.168 810.382H639.04H637.913H636.785H635.658L634.643 810.269L633.628 810.157L632.726 810.044L631.824 809.819L630.922 809.706L630.133 809.481L629.344 809.368L628.554 809.143L627.991 808.917L627.314 808.805L626.75 808.58L626.299 808.467L625.961 808.242L625.623 808.129L625.285 807.904L624.946 807.678L624.157 807.228L623.03 806.664L621.677 805.876L619.985 804.862L618.069 803.736L615.926 802.497L613.558 801.145L610.965 799.681L608.146 798.103L605.327 796.414L602.283 794.612L599.126 792.809L595.969 791.007L592.699 789.092L589.429 787.177L586.047 785.375L582.777 783.46L579.507 781.545L576.237 779.63L573.193 777.827L570.036 776.138L567.104 774.448L564.398 772.758L561.692 771.294L559.324 769.83L557.069 768.591L555.04 767.464L553.348 766.45L551.883 765.549L550.643 764.873L549.853 764.423L549.177 763.972L548.5 763.634L547.936 763.184L547.373 762.846L546.809 762.508L546.358 762.17L545.907 761.719L545.569 761.381L545.118 761.043L544.779 760.705L544.441 760.367L544.216 760.03L543.877 759.692L543.652 759.354L543.426 759.016L543.201 758.678L543.088 758.34L542.975 758.002L542.75 757.664L542.637 757.326L542.524 756.988V756.65L542.412 756.312V755.974Z",
    fill: "url(#paint27_linear_1949_10606)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.103 821.872L628.554 822.097L629.344 822.21L630.133 822.435L630.922 822.548L631.824 822.773L632.726 822.885L633.628 822.998L634.643 823.111L635.658 823.223L636.785 823.336H637.913H639.04H640.168L641.408 823.223L642.648 823.111L643.889 822.885L645.129 822.773L646.369 822.435L647.722 822.097L648.963 821.759L650.315 821.308L651.668 820.858L652.909 820.295L654.262 819.619L655.615 818.943L656.855 818.154L658.321 817.253L660.012 816.239L662.042 815.113L664.184 813.761L666.552 812.297L669.033 810.72L671.738 809.143L674.557 807.453L677.602 805.651L680.646 803.736L683.803 801.821L687.073 799.906L690.23 797.878L693.613 795.963L695.304 794.837V781.995L693.613 783.009L690.23 785.037L687.073 786.952L683.803 788.979L680.646 790.894L677.602 792.697L674.557 794.499L671.738 796.189L669.033 797.878L666.552 799.455L664.184 800.807L662.042 802.159L660.012 803.398L658.321 804.412L656.855 805.313L655.615 806.101L654.262 806.777L652.909 807.453L651.668 808.016L650.315 808.467L648.963 808.917L647.722 809.255L646.369 809.593L645.129 809.819L643.889 810.044L642.648 810.157L641.408 810.269L640.168 810.382H639.04H637.913H636.785H635.658L634.643 810.269L633.628 810.157L632.726 810.044L631.824 809.819L630.922 809.706L630.133 809.481L629.344 809.368L628.554 809.143L628.103 809.03V821.872Z",
    fill: "url(#paint28_linear_1949_10606)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.644 791.007L576.238 792.584L579.507 794.386L582.777 796.301L586.047 798.216L589.429 800.131L592.699 802.046L595.969 803.961L599.126 805.764L602.283 807.566L605.328 809.255L608.147 810.945L610.965 812.522L613.559 813.987L615.926 815.451L618.069 816.69L619.986 817.816L621.677 818.718L623.03 819.506L624.157 820.182L624.946 820.633L625.285 820.858L625.623 820.971L625.961 821.196L626.299 821.308L626.751 821.534L627.314 821.646L627.991 821.872L628.555 822.097L629.344 822.21L630.133 822.435L630.922 822.548L631.825 822.773H631.937V809.931L631.825 809.819L630.922 809.706L630.133 809.481L629.344 809.368L628.555 809.143L627.991 808.917L627.314 808.805L626.751 808.58L626.299 808.467L625.961 808.242L625.623 808.129L625.285 807.904L624.946 807.678L624.157 807.228L623.03 806.665L621.677 805.876L619.986 804.862L618.069 803.736L615.926 802.497L613.559 801.145L610.965 799.681L608.147 798.104L605.328 796.414L602.283 794.612L599.126 792.809L595.969 791.007L592.699 789.092L589.429 787.177L586.047 785.375L582.777 783.46L579.507 781.545L576.238 779.63L573.644 778.166V791.007Z",
    fill: "url(#paint29_linear_1949_10606)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.412 755.974V768.929V769.267L542.524 769.605V769.942L542.637 770.28L542.75 770.618L542.975 770.956L543.088 771.294L543.201 771.632L543.426 771.97L543.652 772.308L543.877 772.646L544.216 772.984L544.441 773.322L544.779 773.66L545.118 773.998L545.569 774.336L545.907 774.674L546.358 775.011L546.809 775.349L547.373 775.8L547.936 776.138L548.5 776.476L549.177 776.926L549.853 777.264L550.643 777.828L551.883 778.503L553.348 779.292L555.04 780.306L557.069 781.432L559.324 782.784L561.692 784.136L564.398 785.713L567.104 787.29L570.036 788.979L573.193 790.782L573.644 791.007V778.165L573.193 777.828L570.036 776.138L567.104 774.448L564.398 772.758L561.692 771.294L559.324 769.83L557.069 768.591L555.04 767.464L553.348 766.45L551.883 765.549L550.643 764.873L549.853 764.423L549.177 763.972L548.5 763.634L547.936 763.184L547.373 762.846L546.809 762.508L546.358 762.17L545.907 761.719L545.569 761.381L545.118 761.043L544.779 760.706L544.441 760.368L544.216 760.03L543.877 759.692L543.652 759.354L543.426 759.016L543.201 758.678L543.088 758.34L542.975 758.002L542.75 757.664L542.637 757.326L542.524 756.988V756.65L542.412 756.312V755.974Z",
    fill: "url(#paint30_linear_1949_10606)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.554 747.639C544.554 747.639 542.412 748.99 542.299 753.046C542.186 757.101 542.525 760.142 549.853 764.31C557.182 768.478 622.917 806.439 625.398 807.904C627.878 809.368 642.987 813.874 656.968 805.313C670.95 796.639 732.174 759.804 735.218 757.664C738.263 755.524 744.351 747.413 735.218 741.556C726.085 735.698 654.037 694.808 650.654 692.781C647.271 690.866 630.922 685.909 619.534 695.822C608.259 705.622 544.554 747.639 544.554 747.639Z",
    fill: "#9E96A1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.299 755.073C542.525 758.227 543.765 760.818 549.854 764.31C557.183 768.591 622.917 806.439 625.398 807.904C627.766 809.255 642.536 813.761 656.292 805.651L589.881 767.351L549.628 750.567L545.231 753.609L542.299 755.073Z",
    fill: "#57556A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.327 625.419L629.456 780.756L634.192 782.221C634.192 782.221 636.447 782.784 638.364 778.841C640.28 774.899 641.633 771.181 642.535 763.747C643.437 756.312 642.986 748.427 639.942 739.641C636.898 730.854 624.608 705.284 622.353 701.004C620.21 696.723 605.891 669.238 604.989 667.661C604.2 666.084 603.861 664.845 601.719 663.718C599.69 662.479 527.528 620.913 526.964 620.575C526.4 620.237 525.949 620.462 525.724 620.8C525.498 621.138 521.327 625.419 521.327 625.419Z",
    fill: "url(#paint31_linear_1949_10606)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.514 678.249C607.582 672.73 605.214 668.224 604.989 667.661C604.2 666.084 603.861 664.845 601.719 663.718L590.669 657.297V705.509H610.514V678.249Z",
    fill: "url(#paint32_linear_1949_10606)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.102 630.375L623.481 791.795L625.398 794.274L630.021 796.526C630.021 796.526 633.178 786.388 634.192 781.77C635.207 777.152 638.364 767.464 637.913 759.692C637.575 751.919 636.448 744.259 630.133 730.742C623.819 717.225 602.96 677.348 601.833 675.208C600.705 673.068 599.577 670.815 599.239 670.252C598.901 669.688 598.563 669.35 597.548 668.787C596.533 668.224 522.681 625.644 522.23 625.306C521.666 624.968 521.215 625.306 521.215 625.306L519.185 627.784L521.102 630.375Z",
    fill: "url(#paint33_linear_1949_10606)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.386 736.599L625.397 794.274C625.397 794.274 630.697 787.74 632.613 780.418C634.53 773.096 636.898 759.804 633.966 750.455C631.035 741.105 619.985 715.985 614.573 705.847C609.161 695.709 597.096 673.068 596.645 672.504C596.194 671.941 595.969 672.054 595.292 671.603C594.616 671.153 520.087 628.01 519.636 627.784C519.185 627.559 518.846 627.897 519.072 628.46C519.297 629.024 523.695 648.286 525.16 654.256C526.626 660.114 530.685 677.461 532.264 682.192C533.73 686.923 534.744 696.948 534.97 702.806C535.421 713.845 531.362 727.363 525.386 736.599Z",
    fill: "url(#paint34_linear_1949_10606)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.386 736.599L625.398 794.273C625.398 794.273 630.697 787.74 632.614 780.418C633.29 777.827 633.967 774.673 634.53 771.069C631.035 778.165 627.314 784.136 626.976 784.811C626.412 785.713 625.397 786.952 624.157 786.276C622.917 785.6 551.77 744.485 549.628 743.358C547.598 742.119 548.049 742.344 547.486 741.105C546.922 739.866 534.181 692.555 534.181 692.443C534.632 696.16 534.857 699.99 534.97 702.806C535.421 713.845 531.362 727.362 525.386 736.599Z",
    fill: "url(#paint35_linear_1949_10606)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.495 810.269C685.495 810.269 698.123 802.947 699.363 802.271C700.604 801.483 703.535 800.244 703.535 795.175C703.535 790.106 703.535 743.471 703.535 743.471L691.132 756.875L687.073 799.906L685.495 810.269Z",
    fill: "url(#paint36_linear_1949_10606)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.602 805.651C677.602 805.651 684.029 807.453 685.269 803.173C686.509 798.892 688.313 762.283 688.313 762.283C689.666 759.579 691.019 756.988 692.372 754.285C692.372 755.974 692.372 757.664 692.372 759.466C692.372 759.466 689.892 800.807 689.779 802.159C689.666 803.51 689.328 806.89 687.299 808.917C685.269 810.945 683.916 810.945 682.225 811.058C680.533 811.058 675.685 809.819 673.994 807.904L677.602 805.651Z",
    fill: "url(#paint37_linear_1949_10606)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.367 804.637C684.705 804.299 685.044 803.736 685.157 803.172C685.495 801.821 685.946 797.54 686.397 792.133L688.877 805.876C688.539 806.89 687.975 807.904 687.186 808.692C686.509 809.368 685.946 809.706 685.495 810.044L684.367 804.637Z",
    fill: "#4F4835"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.184 766.788L664.296 766.901L664.409 767.013L664.522 767.126L664.634 767.239L664.747 767.351L664.86 767.464L665.086 767.577L665.311 767.689L665.536 767.802L665.762 767.915L665.988 768.027L666.213 768.14L666.439 768.253L666.664 768.365L666.889 768.478L667.115 768.703L667.341 768.928L667.566 769.154L667.792 769.379L668.017 769.492L668.243 769.604L668.468 769.717L668.694 769.83L668.919 769.942L669.145 770.055L669.37 770.168L669.596 770.28L669.821 770.393L670.047 770.505L670.272 770.618L670.385 770.731L670.61 770.843L670.836 770.956L671.062 771.069L671.287 771.181H671.512H671.738H671.963H672.189H672.415H672.64H672.865H673.091H673.317H673.542H673.767H673.993H674.218H674.444L674.67 771.069L674.895 770.956L675.12 770.843L675.346 770.731L675.572 770.618L675.797 770.505L676.023 770.393L676.248 770.28L676.473 770.168L676.699 770.055L676.925 769.942L677.15 769.83L677.375 769.604L677.714 769.379L678.278 768.928L679.067 768.365L680.082 767.577L681.322 766.675L682.788 765.662L684.366 764.535L686.057 763.296L687.862 761.944L689.778 760.593L691.808 759.128C695.529 756.537 699.25 753.947 702.858 751.356L705.113 749.779C708.044 747.751 710.863 745.724 713.795 743.583L715.824 742.119L717.741 740.767L719.545 739.528L721.236 738.402L722.702 737.388L724.055 736.487L725.183 735.698L726.084 735.022L726.761 734.572L727.212 734.234L727.438 734.121L727.663 734.008L727.889 733.783L728.114 733.558L728.34 733.333L728.452 733.107L728.565 732.882L728.678 732.544L728.791 732.206V731.868V731.53L728.34 726.687L662.605 760.593L663.056 765.436V765.662L663.169 765.887L663.281 766.112L663.394 766.338L663.507 766.563L664.184 766.788Z",
    fill: "url(#paint38_linear_1949_10606)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663.733 762.057C663.733 762.057 668.356 765.098 670.047 766.112C671.738 767.013 674.67 767.014 677.15 765.099C679.631 763.184 726.423 730.291 727.438 729.503C728.34 728.714 729.693 726.574 727.776 725.11C725.859 723.645 722.702 721.956 721.913 721.392C721.124 720.829 717.741 720.266 716.05 721.392C714.359 722.519 665.086 756.875 663.845 758.115C662.605 759.354 662.944 761.043 663.733 762.057Z",
    fill: "#746E70"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.2 808.692L589.429 819.619L562.143 779.968L586.723 771.97L589.768 773.772L579.169 787.515L594.954 805.876L597.209 804.637L604.2 808.692Z",
    fill: "url(#paint39_linear_1949_10606)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.884 787.402L555.378 776.138L567.217 760.706L586.723 771.97L574.884 787.402Z",
    fill: "#9F9F9F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.884 787.402L555.378 776.138L569.923 808.354L589.429 819.619L574.884 787.402Z",
    fill: "#BABABA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.483 773.547L565.977 762.395L567.218 760.706L586.724 771.97L585.483 773.547Z",
    fill: "#313133"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M535.996 653.876L593.31 682.752L584.468 771.173L570.501 763.455L535.996 653.876ZM585.796 771.907L585.794 771.906L585.796 771.907Z",
    stroke: "#7A7676",
    strokeWidth: 6
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M532.996 653.876L590.31 682.752L581.468 771.173L567.501 763.455L532.996 653.876ZM582.796 771.907L582.794 771.906L582.796 771.907Z",
    stroke: "#A8A8A8",
    strokeWidth: 6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M578 645L528 617.5C530.31 607.541 530.722 601.959 528 592L578 617.5C581.063 626.605 581.033 632.265 578 645Z",
    fill: "#707070"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f_1949_10606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562 629.5L542 618.5L541 622L562 633.5V629.5Z",
    fill: "black"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M533 589L528.5 592.5L578.5 618.5C581.036 629.437 580.582 635.278 578.5 645.5L583 643.5C585.873 632.636 586.361 626.128 583.821 616.03C583.334 614.095 581.971 612.506 580.172 611.642L533 589Z",
    fill: "url(#paint40_linear_1949_10606)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.061 617.359L528.039 592.387L530 591L576.984 615.584C578.491 616.368 579.616 617.762 580.008 619.439C582.254 629.047 581.974 633.883 579.5 644L577.632 645.238C580.046 635.366 580.222 629.141 578.06 619.894C577.807 618.809 577.072 617.884 576.061 617.359Z",
    fill: "url(#paint41_linear_1949_10606)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.822 662.4L564.052 673.327L536.766 633.676L561.346 625.678L562 628.9L553.791 641.223L569.577 659.584L571.832 658.345L578.822 662.4Z",
    fill: "url(#paint42_linear_1949_10606)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.506 641.111L530 629.846L541.839 614.414L561.345 625.678L549.506 641.111Z",
    fill: "#D9D9D9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.506 641.111L530 629.846L544.545 662.063L564.051 673.327L549.506 641.111Z",
    fill: "#BABABA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1949_10606",
    x: 507,
    y: 814.004,
    width: 235.341,
    height: 140.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1949_10606"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1949_10606",
    x: 537,
    y: 614.5,
    width: 29,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1949_10606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_10606",
    x1: 597.381,
    y1: 817.644,
    x2: 620.031,
    y2: 799.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1949_10606",
    x1: 592.093,
    y1: 812.628,
    x2: 589.297,
    y2: 811.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1949_10606",
    x1: 619.574,
    y1: 840.833,
    x2: 647.328,
    y2: 840.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#352E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2E261D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#31281F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#272019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B261F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1949_10606",
    x1: 696.651,
    y1: 823.119,
    x2: 720.827,
    y2: 829.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47483D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#525762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58564A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1949_10606",
    x1: 696.899,
    y1: 820.516,
    x2: 703.383,
    y2: 823.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F261C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1949_10606",
    x1: 702.986,
    y1: 843.973,
    x2: 712.108,
    y2: 817.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E362A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1949_10606",
    x1: 654.579,
    y1: 834.256,
    x2: 689.152,
    y2: 818.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1949_10606",
    x1: 713.617,
    y1: 886.06,
    x2: 737.794,
    y2: 892.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47483D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#525762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58564A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1949_10606",
    x1: 713.864,
    y1: 883.456,
    x2: 720.348,
    y2: 886.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F261C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1949_10606",
    x1: 722.177,
    y1: 907.362,
    x2: 724.024,
    y2: 889.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E362A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1949_10606",
    x1: 668.338,
    y1: 857.898,
    x2: 647.005,
    y2: 851.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33291D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1949_10606",
    x1: 716.181,
    y1: 874.524,
    x2: 722.743,
    y2: 874.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33291D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#473E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1949_10606",
    x1: 642.634,
    y1: 837.717,
    x2: 659.868,
    y2: 844.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1949_10606",
    x1: 614.464,
    y1: 914.751,
    x2: 637.02,
    y2: 920.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5B5559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1949_10606",
    x1: 536.911,
    y1: 869.454,
    x2: 559.467,
    y2: 875.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5B5559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1949_10606",
    x1: 547.73,
    y1: 874.353,
    x2: 570.38,
    y2: 855.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1949_10606",
    x1: 619.996,
    y1: 914.634,
    x2: 617.199,
    y2: 913.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1949_10606",
    x1: 542.442,
    y1: 869.337,
    x2: 539.646,
    y2: 867.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1949_10606",
    x1: 619.856,
    y1: 828.576,
    x2: 647.402,
    y2: 828.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2A2B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C2A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1949_10606",
    x1: 623.935,
    y1: 824.395,
    x2: 643.015,
    y2: 824.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#352E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2E261D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#31281F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#272019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B261F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1949_10606",
    x1: 622.346,
    y1: 876.487,
    x2: 614.661,
    y2: 876.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A5140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1949_10606",
    x1: 633.148,
    y1: 863.525,
    x2: 636.892,
    y2: 848.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1949_10606",
    x1: 632.287,
    y1: 837.87,
    x2: 625.666,
    y2: 862.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1949_10606",
    x1: 534.971,
    y1: 852.128,
    x2: 538.39,
    y2: 852.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#756D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F372B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1949_10606",
    x1: 620.68,
    y1: 844.228,
    x2: 583.429,
    y2: 852.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F372B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1949_10606",
    x1: 558.272,
    y1: 851.74,
    x2: 629.25,
    y2: 830.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F525B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E424A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1949_10606",
    x1: 670.421,
    y1: 678.311,
    x2: 675.73,
    y2: 678.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44392D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1949_10606",
    x1: 733.049,
    y1: 786.558,
    x2: 740.832,
    y2: 786.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686063"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1949_10606",
    x1: 689.488,
    y1: 801.124,
    x2: 676.049,
    y2: 802.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24231F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1949_10606",
    x1: 586.357,
    y1: 803.344,
    x2: 606.543,
    y2: 799.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1949_10606",
    x1: 546.678,
    y1: 773.509,
    x2: 573.925,
    y2: 773.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1949_10606",
    x1: 579.896,
    y1: 676.673,
    x2: 582.565,
    y2: 681.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72666E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1949_10606",
    x1: 588.316,
    y1: 676.588,
    x2: 592.122,
    y2: 680.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72666E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1949_10606",
    x1: 572.66,
    y1: 692.562,
    x2: 576.732,
    y2: 696.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9A9B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A9A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5A534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1949_10606",
    x1: 589.019,
    y1: 682.607,
    x2: 552.639,
    y2: 745.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5E5746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#433B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D3532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1949_10606",
    x1: 567.873,
    y1: 763.508,
    x2: 573.906,
    y2: 753.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1949_10606",
    x1: 702.048,
    y1: 789.863,
    x2: 707.439,
    y2: 799.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1949_10606",
    x1: 677.624,
    y1: 808.827,
    x2: 687.567,
    y2: 786.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47412F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1949_10606",
    x1: 670.827,
    y1: 749.149,
    x2: 675.323,
    y2: 749.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44392D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1949_10606",
    x1: 581.139,
    y1: 782.918,
    x2: 585.414,
    y2: 807.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1949_10606",
    x1: 531.5,
    y1: 591,
    x2: 583,
    y2: 641.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#958892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62545D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1949_10606",
    x1: 529,
    y1: 593.5,
    x2: 585.5,
    y2: 642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646174,
    stopOpacity: 0.353826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1949_10606",
    x1: 555.761,
    y1: 636.626,
    x2: 560.036,
    y2: 660.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2ErgonomicChair);
export default __webpack_public_path__ + "static/media/2ErgonomicChair.1c125cc62c9bc340359e97c940cb604f.svg";
export { ForwardRef as ReactComponent };